import React from "react";
import { Header, Button, Container, Segment, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";

const SignupConfirmation = ({ location }) => {
  const { userId, firstName } = location.state || {};

  return (
    <Container style={{ marginTop: "2em" }}>
      <Segment textAlign="center" padded="very">
        <Icon name="check circle" size="huge" color="green" />
        <Header as="h1" color="purple">
          Account Created Successfully!
        </Header>
        <Header as="h3" color="grey">
          Welcome{firstName ? ` ${firstName}` : ""}! Your account has been created.
        </Header>
        <p>
          You can now access all the features of our platform. 
          {" "}Check your email for a verification message.
        </p>
        <p>
          Someone from our office will contact you shortly.
        </p>
        
        <div style={{ marginTop: "2em" }}>
          {userId && (
            <Button 
              as={Link} 
              to={`/dashboard/profile/${userId}`}
              color="purple" 
              size="large"
              content="View My Profile"
            />
          )}
        </div>
      </Segment>
    </Container>
  );
};

export default SignupConfirmation;
